import { HeroSubpage } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'

/**
 * Creates a mock HeroSubpage
 * @param overrides - Partial fields to override defaults
 * @returns Complete HeroSubpage mock
 */
export function createHeroSubpage(
  overrides: Partial<HeroSubpage> = {}
): HeroSubpage {
  return {
    _uid: 'c7cb1668-ca30-4a9b-8ff4-1693f08cfc3e',
    image: createStoryblokAsset({
      id: 13935669,
      alt: 'Februaraktion',
      title: 'Februaraktion',
      filename:
        'https://a.storyblok.com/f/235453/3000x650/19de963b71/sp-aktion-desktop_mit-text_3000x650.png',
      src: 'https://a.storyblok.com/f/235453/3000x650/19de963b71/sp-aktion-desktop_mit-text_3000x650.png',
      width: 3000,
      height: 650,
      aspect_ratio: 4.62,
      content_type: 'image/png',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    component: 'hero-subpage',
    image_mobile: createStoryblokAsset({
      id: 13935670,
      alt: 'Februaraktion',
      title: 'Februaraktion',
      filename:
        'https://a.storyblok.com/f/235453/768x650/bec0e0d4c4/sp-aktion-tablet_mit-text_768x650.png',
      src: 'https://a.storyblok.com/f/235453/768x650/bec0e0d4c4/sp-aktion-tablet_mit-text_768x650.png',
      width: 768,
      height: 650,
      aspect_ratio: 1.18,
      content_type: 'image/png',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    _editable:
      '<!--#storyblok#{"name": "hero-subpage", "space": "235453", "uid": "c7cb1668-ca30-4a9b-8ff4-1693f08cfc3e", "id": "424177377"}-->',
    ...overrides,
  }
}
